import React, { useState } from 'react'
import { printPDF, printSpreadSheet } from '../../../api/risapi';

const UsersReport = (props) => {

    const { reportLoading,setReportLoading} = props; 
    

    const fetchPdf = async () => {
        setReportLoading(true);
        var reportParameters = {
            selectedOption: "users-list", reportType: "abstract", reportFormat:
                'pdf'
        };

        printPDF('/api/parameter-report/masters', reportParameters, function (response) {
            console.log("print response", response);
            setReportLoading(false);

        });
    };
    const fetchSpreadSheet = async () => {
        setReportLoading(true);
        var reportParameters = { selectedOption: "users-list", reportType: "abstract", reportFormat: 'spreadsheet' };

        printSpreadSheet('/api/parameter-report/masters', reportParameters, function (response) {
            setReportLoading(false);
            console.log("excel print response", response);
        });
    };
    return (
        <>
           
            <div className="m-3 btn-group btn-rtl">
                <button aria-expanded="false" className="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" type="button">
                    Reports <i className="ti ti-arrow-big-down-line" />
                </button>
                <ul className="dropdown-menu" style={{}}>
                    <li><a className="dropdown-item" onClick={fetchPdf} >


                        PDF Report
                        <i class="ms-3 fa-solid fa-file-pdf fa-fw"></i>
                    </a></li>
                    <li><a className="dropdown-item" onClick={fetchSpreadSheet} >SpreadSheet
                        <i className="ms-1 fa-solid fa-file-excel fa-fw" />

                    </a></li>

                </ul>
            </div>
        </>
    )
}

export default UsersReport
